import type { AdminCrewReportOver11MonthsChartProps } from "../../models/admin-crew-report.models";
import { formatAdminCrewReportPeopleCount } from "../../utils/admin-crew-report-statistics.utils";
import { ADMIN_CREW_REPORT_STATISTICS_VIEW_LABELS } from "../../utils/admin-crew-report.constants";
import AdminCrewReportDeskBarChart from "./AdminCrewReportDeskBarChart";

const AdminCrewReportOver11MonthsChart = ({ statistics, view }: AdminCrewReportOver11MonthsChartProps) => {
  const viewLabels = ADMIN_CREW_REPORT_STATISTICS_VIEW_LABELS[view];

  return (
    <AdminCrewReportDeskBarChart
      title={viewLabels.over11MonthsTitle}
      categories={statistics.categories}
      emptyStateMessage={viewLabels.over11MonthsEmptyState}
      accessibleTotalText={`${formatAdminCrewReportPeopleCount(statistics.totalCrewCount, view)} over 11 months in total`}
      accessibleValueKind={view}
      cardDataTest="admin-crew-report-over-11-months-card"
      cardTestId="admin-crew-report-over-11-months-card"
      visualizationTestIdPrefix="admin-crew-report-over-11-months"
      className="md:col-start-2 md:row-start-2"
    />
  );
};

export default AdminCrewReportOver11MonthsChart;
